import { SVGProps, cloneElement } from "react";

import { AtlassianLogoBrandV2 } from "./logos/atlassianv2-logo-brand";
import { AtlassianMarkBrandV2 } from "./logos/atlassianv2-mark-brand";
import { AtlasMarkBrandV2 } from "./logos/atlasv2-mark-brand";
import { BambooMarkBrandV2 } from "./logos/bamboov2-mark-brand";
import { BitbucketMarkBrandV2 } from "./logos/bitbucketv2-mark-brand";
import { CompassMarkBrandV2 } from "./logos/compassv2-mark-brand";
import { ConfluenceLogoBrandV2 } from "./logos/confluencev2-logo-brand";
import { ConfluenceMarkBrandV2 } from "./logos/confluencev2-mark-brand";
import { FocusMarkBrand } from "./logos/focus-mark-brand";
import { GuardMarkBrand } from "./logos/guard-mark-brand";
import { JiraAlignMarkBrandV2 } from "./logos/jiraalignv2-mark-brand";
import { JiraProductDiscoveryLogoBrandV2 } from "./logos/jiraproductdiscoveryv2-logo-brand";
import { JiraProductDiscoveryMarkBrandV2 } from "./logos/jiraproductdiscoveryv2-mark-brand";
import { JiraServiceManagementLogoBrandV2 } from "./logos/jiraservicemanagementv2-logo-brand";
import { JiraServiceManagementMarkBrandV2 } from "./logos/jiraservicemanagementv2-mark-brand";
import { JiraLogoBrandV2 } from "./logos/jirav2-logo-brand";
import { JiraMarkBrandV2 } from "./logos/jirav2-mark-brand";
import { LoomMarkBrandV2 } from "./logos/loom-mark-brand";
import { LoomLogoBrandV2 } from "./logos/loomv2-logo-brand";
import { OpsgenieMarkBrandV2 } from "./logos/opsgeniev2-mark-brand";
import { RovoMarkBrandV2 } from "./logos/rovoV2-mark-brand";
import { StatusPageMarkBrandV2 } from "./logos/statuspagev2-mark-brand";
import { TrelloMarkBrandV2 } from "./logos/trellov2-mark-brand";

export type LogoBrandV2 =
    | "atlassian"
    | "bitbucket"
    | "compass"
    | "confluence"
    | "jira"
    | "jiraalign"
    | "jiraproductdiscovery"
    | "jiraservicemanagement"
    | "trello"
    | "loom"
    | "guard"
    | "rovo"
    | "focus"
    | "opsgenie"
    | "statuspage"
    | "atlas"
    | "bamboo";

export interface LogoPropsV2
    extends Pick<SVGProps<SVGSVGElement>, "height" | "width"> {
    type: "logo" | "mark";
    appearance: "brand" | "inverse" | "neutral";
    brand: LogoBrandV2;
}

type LogoAppearance = {
    brand: JSX.Element;
    inverse?: JSX.Element;
    neutral?: JSX.Element;
};

type LogoType = {
    mark?: LogoAppearance;
    logo?: LogoAppearance;
};

type Logos = { [key in LogoBrandV2]: LogoType };

const Logos: Logos = {
    atlassian: {
        mark: {
            brand: <AtlassianMarkBrandV2 />
        },
        logo: {
            brand: <AtlassianLogoBrandV2 />
        }
    },
    bitbucket: {
        mark: {
            brand: <BitbucketMarkBrandV2 />
        }
    },
    compass: {
        mark: {
            brand: <CompassMarkBrandV2 />
        }
    },
    confluence: {
        mark: {
            brand: <ConfluenceMarkBrandV2 />
        },
        logo: {
            brand: <ConfluenceLogoBrandV2 />
        }
    },
    guard: {
        mark: {
            brand: <GuardMarkBrand />
        }
    },
    focus: {
        mark: {
            brand: <FocusMarkBrand />
        }
    },
    jira: {
        mark: {
            brand: <JiraMarkBrandV2 />
        },
        logo: {
            brand: <JiraLogoBrandV2 />
        }
    },
    jiraalign: {
        mark: {
            brand: <JiraAlignMarkBrandV2 />
        }
    },
    jiraservicemanagement: {
        mark: {
            brand: <JiraServiceManagementMarkBrandV2 />
        },
        logo: {
            brand: <JiraServiceManagementLogoBrandV2 />
        }
    },
    jiraproductdiscovery: {
        logo: {
            brand: <JiraProductDiscoveryLogoBrandV2 />
        },
        mark: {
            brand: <JiraProductDiscoveryMarkBrandV2 />
        }
    },
    loom: {
        mark: {
            brand: <LoomMarkBrandV2 />
        },
        logo: {
            brand: <LoomLogoBrandV2 />
        }
    },
    rovo: {
        mark: {
            brand: <RovoMarkBrandV2 />
        }
    },
    trello: {
        mark: {
            brand: <TrelloMarkBrandV2 />
        }
    },
    opsgenie: {
        mark: {
            brand: <OpsgenieMarkBrandV2 />
        }
    },
    statuspage: {
        mark: {
            brand: <StatusPageMarkBrandV2 />
        }
    },
    atlas: {
        mark: {
            brand: <AtlasMarkBrandV2 />
        }
    },
    bamboo: {
        mark: {
            brand: <BambooMarkBrandV2 />
        }
    }
};

export const LogoV2 = ({
    brand,
    type,
    appearance,
    width,
    height
}: LogoPropsV2) => {
    const logo = Logos[brand]?.[type]?.[appearance];

    return logo ? cloneElement(logo, { width, height }) : logo;
};
